import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography} from 'views/components';
import {Translate} from 'views/module';

import FormEdit from './edit/FormEdit';
import FormView from './view/FormView';

const FormPreview = (props) => {
  const {data, manuallyUpdateField} = props;

  const [editMode, setEditMode] = React.useState(false);

  return (
    <Box sx={{position: 'relative', width: '100%', height: '100%'}}>
      <Box sx={{position: 'relative', width: '100%', height: '100%'}}>
        <Box sx={{overflowY: 'auto', height: '100%', p: 2, position: 'relative'}}>
          <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
            <Typography variant="h6" fontWeight={600} gutterBottom>
              <Translate expression="profile.FormPreview.Title" />
            </Typography>
          </Box>
          {
            !editMode &&
            <FormView
              data={data}
              setEditMode={setEditMode}
            />
          }
          {
            editMode &&
            <FormEdit
              data={data}
              manuallyUpdateField={manuallyUpdateField}
              setEditMode={setEditMode}
            />
          }
        </Box>
      </Box>
    </Box>
  );
};

FormPreview.propTypes = {
  data: PropTypes.object.isRequired,
  manuallyUpdateField: PropTypes.func.isRequired,
};

export default FormPreview;
